/**
 * Composed API client — domain modules in ./domains/
 */
import { authApi } from './domains/auth.js'
import { tenantsApi } from './domains/tenants.js'
import { superAdminsApi } from './domains/superAdmins.js'
import { platformApi } from './domains/platform.js'
import { tenantPeopleApi } from './domains/tenantPeople.js'
import { clientsApi } from './domains/clients.js'
import { campaignsApi } from './domains/campaigns.js'
import { influencersApi } from './domains/influencers.js'
import { createAssignmentsApi } from './domains/assignments.js'
import { deliverablesApi } from './domains/deliverables.js'
import { createContentApi } from './domains/content.js'
import { contentVaultApi } from './domains/contentVault.js'
import { statsApi } from './domains/stats.js'
import { feedbackApi } from './domains/feedback.js'
import { earningsApi } from './domains/earnings.js'
import { notesApi } from './domains/notes.js'
import { invoicesApi } from './domains/invoices.js'
import { metricEvidenceApi } from './domains/metricEvidence.js'
import { billingApi } from './domains/billing.js'

export const api = {
  auth: authApi,
  tenants: tenantsApi,
  superAdmins: superAdminsApi,
  platform: platformApi,
  tenantPeople: tenantPeopleApi,
  clients: clientsApi,
  campaigns: campaignsApi,
  influencers: influencersApi,
  assignments: createAssignmentsApi(),
  deliverables: deliverablesApi,
  content: createContentApi(),
  contentVault: contentVaultApi,
  stats: statsApi,
  feedback: feedbackApi,
  earnings: earningsApi,
  notes: notesApi,
  invoices: invoicesApi,
  metricEvidence: metricEvidenceApi,
  billing: billingApi,
}

export default api

export {
  getApiConnectionErrorMessage,
  getApiAssetUrl,
  getContentFileUrl,
  getContentDisplayUrl,
  getContentFullAssetUrl,
} from './configAndUrls.js'

export { getApiErrorMessage, getApiErrorDetail, formatApiErrorForDisplay } from '../apiErrors.js'

export {
  getTenantSlug,
  setTenantSlug,
  getAuthHeaders,
  apiRequest,
  isInfluencerRosterDuplicateError,
  influencerRosterDuplicateMessage,
} from './http.js'
